module.exports = __webpack_public_path__ + "thumbs-up.png";